/* eslint-disable react-refresh/only-export-components */
import React, { createContext, useContext, useState, useCallback } from 'react';

type DashboardContextType = {
  isOpenDrawer: boolean;
  toggleSidebar: () => void;
  isOpenDropdown: boolean;
  toggleDropdown: () => void;
};

const DashboardContext = createContext<DashboardContextType | undefined>(undefined);

export const DashboardLayoutProvider = ({ children }: { children: React.ReactNode }) => {
  const [isOpenDrawer, setIsOpenDrawer] = useState(false);
  const [isOpenDropdown, setIsOpenDropdown] = useState(false);

  const toggleSidebar = useCallback(() => setIsOpenDrawer((prev) => !prev), []);
  const toggleDropdown = useCallback(() => setIsOpenDropdown((prev) => !prev), []);

  return (
    <DashboardContext.Provider
      value={{ isOpenDrawer, toggleSidebar, isOpenDropdown, toggleDropdown }}
    >
      {children}
    </DashboardContext.Provider>
  );
};

export const useDashboardContext = () => {
  const context = useContext(DashboardContext);
  if (!context) {
    throw new Error('useDashboardContext must be used within DashboardLayoutProvider');
  }
  return context;
};
